module.exports = __webpack_public_path__ + "img/endmarker-min.90ffa936.png";